class TechnicalEnviromentMessage {
  static LOCAL_STORAGE_KEY = 'tuMessage';

  // List of active pages where the message should be shown
  static ON_PAGES_ACTIVE = [
    'body[data-id-area="1"][data-bool-gattungsobjekt="n"]', // Product family pages
    'body[data-id-objekt="7093"]', // Product Finder
    'body[data-id-objekt="7449"]', // Stromschienen Konfigurator
    'body[data-id-objekt="7678"]', // Invia Konfigurator
    'body[data-id-objekt="7987"]', // Product Finder 2.0
  ]

  static MAPPINGS_TU = {
    'de': 'global',
    'en': 'global',
    'fr': 'global',
    'es': 'global',
    'it': 'global',
    'nl': 'global',
    'us': 'usa',
  }

  static pageIso = null;

  static EXPIRATION_TIME = 365 * 24 * 60; // Expires in 1 year

  static initialChecked = false;

  /**
   * Initialize the message
   *  
   */
  static init() {
    if (!TechnicalEnviromentMessage.isActivePage()) {
      TechnicalEnviromentMessage.dispatchInitialChecked();
      return;
    }

    let userIso = kmcookie.lesen('erco-lang')
    userIso = userIso === 'en_us' ? 'us' : userIso;

    const userTU = TechnicalEnviromentMessage.MAPPINGS_TU[userIso] ?? '';

    const contactJSONIso = (userIso === 'en') ? 'gb' : userIso || '';

    const urlContactJSON = `${confEnv['pdb_api_url']}/contact/get_contact_json/${contactJSONIso}`;

    fetch(urlContactJSON).then(response => response.json()).then(data => {
      const localizedTU = data.technical_enviroment;
      const localizedIso = data.preferred_language;

      let pageIso = k3vars.S_Sprache;
      pageIso = pageIso === 'en_us' ? 'us' : pageIso;
      const pageTU = TechnicalEnviromentMessage.MAPPINGS_TU[pageIso];
      let copyTUBanner = null;

      if (pageTU === 'global') {
        copyTUBanner = data.tu_banner_copy_global
      } else {
        copyTUBanner = data.tu_banner_copy_usa
      }

      const storageObject = window.toolkit.getLocalStorageObject(TechnicalEnviromentMessage.LOCAL_STORAGE_KEY);
      let preSelectedIso = null;

      // get template 
      const tuBannerTemplate = document.querySelector('template[data-overlay-item-template="tu-message"]');
      if (!tuBannerTemplate) {
        TechnicalEnviromentMessage.dispatchInitialChecked();
        return;
      }
      const tuBannerClone = tuBannerTemplate.content.cloneNode(true);

      // get render element from template
      const templateRenderElement = tuBannerClone.querySelector('[data-tu-render-mustache]');
      if (!templateRenderElement) {
        TechnicalEnviromentMessage.dispatchInitialChecked();
        return;
      }

      globals.renderSingleMustacheTemplate(templateRenderElement, data).then((data) => {
        // Check if the user has already confirmed the TU
        if (storageObject && storageObject.selectedTU && storageObject.selectedIso) {
          const confirmedTU = storageObject.selectedTU;
          const confirmedIso = storageObject.selectedIso;

          if (pageTU === confirmedTU && pageTU === userTU) {
            TechnicalEnviromentMessage.dispatchInitialChecked();
            return;
          } else {
            preSelectedIso = confirmedIso;
          }

          // Check if the user has a preferred TU saved in the language cookie
        } else if (userIso) {
          if (pageTU === userTU) {
            TechnicalEnviromentMessage.dispatchInitialChecked();
            return;
          } else {
            preSelectedIso = userIso;
          }
        } else if (pageTU === localizedTU) {
          TechnicalEnviromentMessage.dispatchInitialChecked();
          return;
        } else {
          preSelectedIso = localizedIso;
        }

        // add tu banner to DOM and reselect element
        tuBannerTemplate.parentNode.appendChild(tuBannerClone);
        const renderElement = document.querySelector('[data-tu-render-mustache]');
        if (!renderElement) {
          TechnicalEnviromentMessage.dispatchInitialChecked();
          return;
        }
        renderElement.innerHTML = data;
        TechnicalEnviromentMessage.show(preSelectedIso, pageIso, copyTUBanner);
      });
    }).catch(error => {
      TechnicalEnviromentMessage.dispatchInitialChecked();
      console.log('error', error);
      return;
    });
  }

  /**
   * Show the message
   *  
   * @param {string} preselectedIso - The iso code which should be preselected
   * @param {string} pageIso - The current iso code of the page
   * @param {string} copyTU - The copy of the TU message
   */
  static show(preselectedIso, pageIso, currentTU) {
    const tuInteractionHandlesElement = document.querySelector('[data-overlay-item="tu-message"]');
    if (!tuInteractionHandlesElement) {
      return;
    }
    const copyTU = document.querySelector('[data-tu-copy]');
    copyTU.innerHTML = currentTU;

    const selectTU = document.querySelector('[data-tu-select-tu]');
    selectTU.value = preselectedIso;

    tuInteractionHandlesElement.addEventListener('click', function (event) {
      if (event.target.dataset.tuBtn === 'nav_tu_confirm') {

        const selectTU = document.querySelector('[data-tu-select-tu]');
        let selectedISO = selectTU.options[selectTU.selectedIndex].value;
        TechnicalEnviromentMessage.setTechnicalEnviorment(selectedISO);

        if (selectedISO !== pageIso) {
          selectedISO = selectedISO === 'us' ? 'en_us' : selectedISO;
          document.dispatchEvent(new CustomEvent('selectLanguage', { detail: { language: selectedISO } }));
        }

        kmcookie.setzen("erco-lang", selectedISO);
        TechnicalEnviromentMessage.hide();
      } else if (event.target.dataset.tuBtn === 'nav_tu_cancel') {
        TechnicalEnviromentMessage.hide();
      };
    });

    // check if specsheet and phaseout are shown if applicable
    TechnicalEnviromentMessage.waitForDialogsChecked().then(() => {
      document.dispatchEvent(new CustomEvent('showTUMessage'));
      TechnicalEnviromentMessage.dispatchInitialChecked();
    });
  }

  static isActivePage() {
    return TechnicalEnviromentMessage.ON_PAGES_ACTIVE.some(selector => document.querySelector(`${selector}`));
  }

  static setInitialTechnicalEnviroment(isoLanguage) {
    let storageObject = window.toolkit.getLocalStorageObject(TechnicalEnviromentMessage.LOCAL_STORAGE_KEY);
    if (storageObject && storageObject.selectedTU && storageObject.selectedIso) {
      return;
    }
    TechnicalEnviromentMessage.setLocalStorageObject(isoLanguage);
   }

  static setTechnicalEnviorment(isoLanguage) {
    const isActivePage = TechnicalEnviromentMessage.isActivePage()
    if (!isActivePage) {
      return;
    }
    TechnicalEnviromentMessage.setLocalStorageObject(isoLanguage);
  }

  static setLocalStorageObject(isoLanguage) { 
    const selectedTU = TechnicalEnviromentMessage.MAPPINGS_TU[isoLanguage];
    if (!selectedTU) {
      return;
    }
    const storageObject = {
      selectedTU,
      selectedIso: isoLanguage
    };
    window.toolkit.setLocalStorageObject(TechnicalEnviromentMessage.LOCAL_STORAGE_KEY, storageObject, TechnicalEnviromentMessage.EXPIRATION_TIME) // Expires in 1 year
  }

  /**
   * Hide the message
   */
  static hide() {
    // hide cookieMessage
    document.dispatchEvent(new CustomEvent('hideTUMessage'));
  }

  static dispatchInitialChecked() {
    TechnicalEnviromentMessage.initialChecked = true;
    document.dispatchEvent(new Event('technical-environment:checked'));
  }

  // Function returns a promise that resolves if all events for overlays have been initially checked
  static waitForDialogsChecked() {
    return new Promise((resolve) => {
      const allDone = () => (
        window.productHeaderTooltip.initialOverlayChecked &&
        window.Specsheets.initialChecked
      );

      if (allDone()) {
        resolve();
        return;
      }

      const onAny = () => {
        if (allDone()) {
          cleanup();
          resolve();
        }
      };
      document.addEventListener('phaseoutOverlay:checked', onAny);
      document.addEventListener('specsheet:checked', onAny);

      const cleanup = () => {
        document.removeEventListener('phaseoutOverlay:checked', onAny);
        document.removeEventListener('specsheet:checked', onAny);
      };
    });
  }

}
